import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { BillMergeDataset } from './bill.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.PrepaymentSupplier,
    dependsOn: [
        ActivityEntityName.Job,
        ActivityEntityName.WorkOrder,
    ]
})
export class PrepaymentSupplierMergeDataset extends BillMergeDataset {
}


